import { render, staticRenderFns } from "./PlaylistsPanelStudentItemCard.vue?vue&type=template&id=0d16afc8&scoped=true&"
import script from "./PlaylistsPanelStudentItemCard.vue?vue&type=script&lang=ts&"
export * from "./PlaylistsPanelStudentItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistsPanelStudentItemCard.vue?vue&type=style&index=0&id=0d16afc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16afc8",
  null
  
)

export default component.exports